// import React, { Component } from 'react';
// import { connect } from 'react-redux';
// import { withRouter } from 'react-router-dom';

// import { logoutUser } from '../../store/actions';

// class Logout extends Component {
//     /**
//      * Redirect to login
//      */
//     componentDidMount = () => {
//         // emit the event
//          this.props.logoutUser(this.props.history);
         
//     };

//     render() {
//         return <React.Fragment></React.Fragment>;
//     }
// }

// export default withRouter(
//     connect(
//         null,
//         { logoutUser }
//     )(Logout)
// );


import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { logoutUser } from '../../store/actions';

class Logout extends Component {

    componentDidMount() {
        // show screen for a short moment then logout
        setTimeout(() => {
            this.props.logoutUser(this.props.history);
        }, 800); // 0.8s delay for better UX
    }

    render() {
        return (
            <div style={styles.container}>
                <div style={styles.card}>
                    <div style={styles.loader}></div>
                    <h3 style={styles.text}>Logging you out...</h3>
                </div>
            </div>
        );
    }
}

const styles = {
    container: {
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f7f8fa"
    },
    card: {
        padding: "40px 60px",
        background: "#fff",
        boxShadow: "0px 3px 12px rgba(0,0,0,0.1)",
        borderRadius: "10px",
        textAlign: "center"
    },
    text: {
        marginTop: "20px",
        fontSize: "18px",
        color: "#333"
    },
    loader: {
        width: "40px",
        height: "40px",
        borderRadius: "50%",
        border: "4px solid #ddd",
        borderTopColor: "#ff6600",
        animation: "spin 1s linear infinite"
    }
};

// Add CSS animation globally
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
document.head.appendChild(styleSheet);

export default withRouter(connect(null, { logoutUser })(Logout));
